theme.footerSection = (function () {
  function footer() {

    /* =========================================================
       MOBILE NAVIGATION BAR
       ========================================================= */

    const mobileNavigateBar = document.querySelector(
      ".mobile__navigation--bar"
    );

    if (mobileNavigateBar) {
      document.documentElement.style.setProperty(
        "--mobile-navigation-bar-height",
        `${mobileNavigateBar.clientHeight}px`
      );

      window.addEventListener("resize", function () {
        document.documentElement.style.setProperty(
          "--mobile-navigation-bar-height",
          `${mobileNavigateBar.clientHeight}px`
        );
      });
    }


    /* =========================================================
       FOOTER ACCORDION
       Solo CONÓCENOS y POLÍTICAS
       ========================================================= */

    const initFooterAccordion = function () {

      const widgets = document.querySelectorAll(
        ".footer-block-about .footer__widget, .footer-block-menu .footer__widget"
      );

      widgets.forEach(function (widget) {

        const button = widget.querySelector(
          ".footer__widget_toggle"
        );

        const content = widget.querySelector(
          ".footer__widget_inner"
        );

        if (!button || !content) return;

        /* Evitar registrar el mismo evento varias veces */
        if (button.dataset.footerAccordionReady === "true") {
          return;
        }

        button.dataset.footerAccordionReady = "true";

        button.setAttribute("aria-expanded", "false");

        button.addEventListener("click", function (event) {

          event.preventDefault();
          event.stopPropagation();

          const isOpen = widget.classList.contains("is-open");

          /* Cerrar otros acordeones */
          document
            .querySelectorAll(
              ".footer-block-about .footer__widget.is-open, .footer-block-menu .footer__widget.is-open"
            )
            .forEach(function (otherWidget) {

              if (otherWidget !== widget) {

                otherWidget.classList.remove("is-open");

                const otherButton =
                  otherWidget.querySelector(
                    ".footer__widget_toggle"
                  );

                const otherContent =
                  otherWidget.querySelector(
                    ".footer__widget_inner"
                  );

                if (otherButton) {
                  otherButton.setAttribute(
                    "aria-expanded",
                    "false"
                  );
                }

                if (otherContent) {
                  otherContent.style.display = "none";
                }
              }
            });


          /* Abrir / cerrar el seleccionado */
          if (isOpen) {

            widget.classList.remove("is-open");

            button.setAttribute(
              "aria-expanded",
              "false"
            );

            content.style.display = "none";

          } else {

            widget.classList.add("is-open");

            button.setAttribute(
              "aria-expanded",
              "true"
            );

            content.style.display = "block";
          }

        });
      });
    };


    /* Inicializar */
    initFooterAccordion();


    /* =========================================================
       DESKTOP
       ========================================================= */

    const handleFooterResize = function () {

      if (window.innerWidth >= 750) {

        document
          .querySelectorAll(".footer__widget")
          .forEach(function (widget) {

            widget.classList.remove("is-open");
            widget.classList.remove("active");

            const content =
              widget.querySelector(
                ".footer__widget_inner"
              );

            if (content) {
              content.style.display = "";
            }

          });

      }

    };


    window.addEventListener(
      "resize",
      handleFooterResize
    );


    /* =========================================================
       SHOPIFY THEME EDITOR
       ========================================================= */

    document.addEventListener(
      "shopify:section:load",
      function () {
        initFooterAccordion();
      }
    );

  }

  return footer;

})();